import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const miniCardRecipeFn = /* @__PURE__ */ createRecipe('miniCard', {}, [])

const miniCardRecipeVariantMap = {
  "variant": [
    "info",
    "status"
  ],
  "status": [
    "success",
    "danger",
    "confirmed",
    "selected",
    "dimmed",
    "unknown"
  ]
}

const miniCardRecipeVariantKeys = Object.keys(miniCardRecipeVariantMap)

export const miniCardRecipe = /* @__PURE__ */ Object.assign(memo(miniCardRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'miniCardRecipe',
  __getCompoundVariantCss__: miniCardRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: miniCardRecipeVariantKeys,
  variantMap: miniCardRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, miniCardRecipeVariantKeys)
  },
  getVariantProps: miniCardRecipeFn.getVariantProps,
})